import store from 'utils/store';
import { hasPrivilege, isTeamManager, PLAYLIST_WRITE } from 'utils/privileges';
import config from 'utils/config';
export function getIsPlaylistEditable(_ref) {
  var playlist = _ref.playlist,
    _ref$allowEditingDist = _ref.allowEditingDistributedPlaylists,
    allowEditingDistributedPlaylists = _ref$allowEditingDist === void 0 ? false : _ref$allowEditingDist;
  if (!allowEditingDistributedPlaylists) {
    var isDistributedPlaylist = playlist.domain_id && +store('domainId') !== +playlist.domain_id;
    if (isDistributedPlaylist) {
      return false;
    }
  }
  return !!(hasPrivilege(PLAYLIST_WRITE) || config.enableTeamPlaylists && playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId));
}